export const createEditorWindowName = (pageId: string) => `SHOWROOM_CMS_EDITOR__PAGE${pageId}`;
